import { useDispatch, useSelector } from "react-redux";
import Header from "../components/Header";
import React from "react";
import { createDocuments, deleteDocuments, listDocuments } from "../actions/documentActions";
import { useEffect, useState } from "react";
import { documentFilterJson, documentJson } from "../models/documentModel";
import { providerEnum } from "../data/providers";
import LeftComponent from "../components/LeftComponent";
import ReactPaginate from "react-paginate";
import SubAgent from "../components/SubAgent";
import Partner from "../components/Partner";
import Universities from "../components/Universities";
import AffiliatePartner from "../components/AffiliatePartner";
import { format } from "date-fns";
import { DOCUMENT_CREATE_RESET, DOCUMENT_DELETE_RESET } from "../constants/documentConstants";
import DocumentTypes from "../components/DocumentTypes";

export default function Document() {
  const dispatch = useDispatch();
  const { loading, error, documents, totalDocs } = useSelector(
    (s) => s.documentList
  );

  const {
    loading: loadingCreate,
    error: errorCreate,
    success,
  } = useSelector((s) => s.documentCreate);

  const {
    loading: loadingDelete,
    error: errorDelete,
    success: successDelete,
  } = useSelector((s) => s.documentDelete);

  const [docJson, setdocJson] = useState(documentFilterJson);
  const [createDocJson, setcreateDocJson] = useState(documentJson);
  const [openCreate, setopenCreate] = useState(false);
  const [selectedProvider, setSelectedProvider] = useState("");
  const [selectedProvider1, setSelectedProvider1] = useState("");
  const [file_input, setfile_input] = useState("");

  const getDocumentList = () => {
    dispatch(listDocuments(docJson));
  };

  const applyPageFilter = (e) => {
    console.log(e.selected);
    setdocJson({ ...docJson, PageNo: 1 + e.selected });
    getDocumentList();
  };

  const handleDocFilters = (e) => {
    e.preventDefault();
    setdocJson({ ...docJson, [e.target.name]: e.target.value, PageNo: "1" });
    getDocumentList();
  };

  const handleDocFilterProvider = (e) => {
    setSelectedProvider1(e.target.value);
    setdocJson({
      ...docJson,
      [e.target.name]: e.target.value,
      providerId: "0",
      PageNo: "1",
    });
    getDocumentList();
  };

  const handleValues = (e) => {
    if (e.target.name == "document") {
      setcreateDocJson({
        ...createDocJson,
        [e.target.name]: e.target.files[0],
      });
      setfile_input(e.target.value);
    } else {
      setcreateDocJson({ ...createDocJson, [e.target.name]: e.target.value });
    }
  };

  const handleProviderValues = (e) => {
    setSelectedProvider(e.target.value);
    const folderName = providerEnum.find((r) => r.id == e.target.value).name;
    setcreateDocJson({
      providerid: 0,
      [e.target.name]: e.target.value,
      FolderName: folderName.replaceAll(" ", ""),
    });
  };

  const handleUpload = (e) => {
    e.preventDefault();
    const formData = new FormData();
    for (let key in createDocJson) {
      formData.append(key, createDocJson[key]);
    }

    dispatch(createDocuments(formData, createDocJson.FolderName));
  };

  const handleDelete = (id)=>{
    dispatch(deleteDocuments(id));
  }

  useEffect(() => {
    if (!documents) {
      getDocumentList();
    }
    if (success) {
      setcreateDocJson(documentJson);
      setfile_input("");
      setSelectedProvider(0);
      setopenCreate(false);
      dispatch({ type: DOCUMENT_CREATE_RESET });
      getDocumentList();
    }
    if (successDelete) {
        dispatch({ type: DOCUMENT_DELETE_RESET });
        getDocumentList();
      }
  }, [dispatch, documents, success, successDelete]);
  return (
    <>
      <Header pageName="Document Dashboard" />
      <LeftComponent>
        <div className="content-body">
          <div className="container-fluid">
            <div className="inner-body">
              <div className="row">
                <div className="col-md-3 col-lg-2">
                  <div className="filter-in-mob-view text-right">
                    {/* <input
                      type="text"
                      name="search"
                      placeholder="Search Provider..."
                    />
                    <i className="fas fa-filter mob-nav-open"></i> */}
                  </div>
                  {/* <!-- /filter-in-mob-view --> */}

                  <div className="add-filter">
                    <div className="filter-title  filter-title-mob">
                      <h5>Filter Documents </h5>
                      <button className="mob-nav-open">☰</button>
                    </div>
                    <div className="filter-body filter-body-mob custom-scroll-right pt-0">
                      <div className="sticky pt-2">
                        <button className="btn btn-sm btn-deep-orange">
                          Reset filters
                        </button>
                        <br />
                      </div>

                      <ul className="modify-filter-title">
                        <li>Provider:</li>
                        <li>
                          <select
                            className="form-control"
                            name="provider"
                            value={docJson.provider}
                            onChange={(e) => handleDocFilterProvider(e)}
                          >
                            <option value="0">--Select--</option>
                            {providerEnum.map((rec) => (
                              <option value={rec.id}>{rec.name}</option>
                            ))}
                          </select>
                        </li>

                        {selectedProvider1 == "1" ? (
                          <>
                            <li>University:</li>
                            <li>
                              <select
                                className="form-control"
                                name="providerId"
                                value={docJson.providerId}
                                onChange={(e) => handleDocFilters(e)}
                              >
                                <option value="0">--Select--</option>
                                <Universities />
                              </select>
                            </li>
                          </>
                        ) : selectedProvider1 == "2" ? (
                          <>
                            <li>Affiliate Partner:</li>
                            <li>
                              <select
                                className="form-control"
                                name="providerId"
                                value={docJson.providerId}
                                onChange={(e) => handleDocFilters(e)}
                              >
                                <option value="0">--Select--</option>
                                <AffiliatePartner />
                              </select>
                            </li>
                          </>
                        ) : selectedProvider1 == "3" ? (
                          <>
                            <li>Partner Agent:</li>
                            <li>
                              <select
                                className="form-control"
                                name="providerId"
                                value={docJson.providerId}
                                onChange={(e) => handleDocFilters(e)}
                              >
                                <option value="0">--Select--</option>
                                <Partner />
                              </select>
                            </li>
                          </>
                        ) : selectedProvider1 == "4" ? (
                          <>
                            <li>Sub Agent:</li>
                            <li>
                              <select
                                className="form-control"
                                name="providerId"
                                value={docJson.providerId}
                                onChange={(e) => handleDocFilters(e)}
                              >
                                <option value="0">--Select--</option>
                                <SubAgent />
                              </select>
                            </li>
                          </>
                        ) : (
                          ""
                        )}

                        <li>Document:</li>
                        <li>
                          <select
                            className="form-control"
                            name="docType"
                            value={docJson.docType}
                            onChange={(e) => handleDocFilters(e)}
                          >
                            <option value="0">--Select--</option>
                            <DocumentTypes />
                          </select>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="col-md-9 col-lg-10">
                  <div className="row">
                    <div className="col-md-12 ">
                      <div className="home-table-search float-right d-flex">
                        <div className="input-group search-contacts">
                          {/* <input
                            type="text"
                            id="searchContact"
                            className="form-control ng-pristine ng-valid ng-empty ng-touched"
                            placeholder="Search Invoice"
                            name="searchtxt"
                          />
                          <i className="fa fa-search" aria-hidden="true"></i> */}
                        </div>
                        <div className="right-click Create-btn">
                          <a
                            className="btn create-contact"
                            onClick={(e) => setopenCreate(true)}
                          >
                            Upload Document
                          </a>
                        </div>
                      </div>
                      {/* <input type="text" className="form-control sm" />
                                            <Link to="/invoice/create" target="_blank" className='a-btn'>Add Invoice</Link> */}
                    </div>
                  </div>

                  <div className="coctacts-table">
                    <div className="table-responsive custom-scroll-right-bottum">
                      <table className="table table-condensed ">
                        <thead className="t-head-th-bg">
                          <tr>
                            <th className="t-head-fixed"></th>
                            <th className="t-head-fixed">
                              Service Provider Type
                            </th>
                            <th className="t-head-fixed">Provider Name</th>
                            <th className="t-head-fixed">Document Name</th>
                            <th>Document</th>
                            <th>Uploaded Date</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody className="table-bordered">
                          {loading ? (
                            <tr>
                              <td colSpan="11">Loading...</td>
                            </tr>
                          ) : (
                            <>
                              {documents ? (
                                documents.length > 0 ? (
                                  documents.map((rec) => {
                                    var lnk = `/invoice/edit/${rec.Id}`;
                                    return (
                                      <tr key={rec.Id}>
                                        <td></td>
                                        <td>{rec.Provider_Type}</td>
                                        <td>{rec.Provider_Name}</td>
                                        <td>{rec.DocumentName}</td>
                                        <td>
                                          <a
                                            href={
                                              process.env
                                                .REACT_APP_SEARCH_DOC_URL +
                                              "/" +
                                              rec.Provider_Type.replaceAll(
                                                " ",
                                                ""
                                              ) +
                                              "/" +
                                              rec.fileName
                                            }
                                            target="_blank"
                                          >
                                            {rec.fileName}
                                          </a>
                                        </td>
                                        <td>
                                          {format(
                                            new Date(rec.CreatedOn),
                                            "dd-MM-yyyy hh:mm a"
                                          )}
                                        </td>
                                        <td>
                                          <a style={{ color: "red" }} onClick={e=>handleDelete(rec.Id)}>
                                            Delete
                                          </a>
                                        </td>
                                      </tr>
                                    );
                                  })
                                ) : (
                                  <tr>
                                    <td colSpan="8">{error}</td>
                                  </tr>
                                )
                              ) : (
                                <>
                                  <tr>
                                    <td colSpan="8">{error}</td>
                                  </tr>
                                </>
                              )}
                            </>
                          )}
                        </tbody>
                      </table>
                    </div>

                    <div className="table-page-details">
                      <div className="row">
                        <div className="col-md-9">
                          <ReactPaginate
                            className="pagination justify-content-center"
                            activeClassName="activeClass"
                            breakLabel="..."
                            nextLabel="Next"
                            nextClassName="nextClass"
                            previousClassName="previousClass"
                            pageClassName="page-item"
                            onPageChange={(e) => applyPageFilter(e)}
                            pageRangeDisplayed={5}
                            pageCount={
                              totalDocs &&
                              Math.ceil(totalDocs / docJson.PageSize)
                            }
                            previousLabel="Previous"
                            renderOnZeroPageCount={null}
                            pageLinkClassName="page-link"
                          />
                          {/* <div className="page-number">
                                                        <ul className="pagination justify-content-center">
                                                            <li className="page-item">
                                                                <a className="page-link" href="#" tabindex="-1">Previous</a>
                                                            </li>
                                                            <li className="page-item">
                                                                <a className="page-link" href="#">1</a>
                                                            </li>
                                                            <li className="page-item">
                                                                <a className="page-link" href="#">2</a>
                                                            </li>
                                                            <li className="page-item">
                                                                <a className="page-link" href="#">3</a>
                                                            </li>
                                                            <li className="page-item">
                                                                <a className="page-link" href="#">Next</a>
                                                            </li>
                                                        </ul>
                                                    </div> */}
                        </div>
                        <div className="col-md-3 text-center">
                          <div className="page-counter">
                            <label>
                              Showing &nbsp;
                              <select
                                name="PageSize"
                                value={docJson.PageSize}
                                onChange={(e) => handleDocFilters(e)}
                              >
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                              </select>{" "}
                              of <span>{totalDocs && totalDocs}</span> records
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Modal for adding the records */}

            <div
              id="CreatContact"
              class={`overlay-note ${openCreate ? "showCreate" : ""}`}
            >
              <div className="overlay-add-deals contact-right-side">
                <div className="note-title">
                  <h4 className="text-left text-white pl-3">Upload Document</h4>
                  <a
                    href="javascript:void(0)"
                    className="closebtn text-right text-white"
                    onClick={(e) => setopenCreate(false)}
                  >
                    &times;
                  </a>
                </div>
                <div className="contact-body modify-create-contact">
                  <div className="form-group">
                    <label>
                      Provider:<b>*</b>
                    </label>
                    <select
                      className="form-control"
                      name={"provider"}
                      value={createDocJson.provider}
                      onChange={(e) => {
                        handleProviderValues(e);
                      }}
                    >
                      <option value="">--Select--</option>
                      {providerEnum.map((rec) => (
                        <option value={rec.id}>{rec.name}</option>
                      ))}
                    </select>
                  </div>
                  {selectedProvider === "1" ? (
                    <div className="form-group">
                      <label>
                        University:<b>*</b>
                      </label>
                      <select
                        className="form-control"
                        name="providerid"
                        value={createDocJson.providerid}
                        onChange={(e) => handleValues(e)}
                      >
                        <option value="0">--Select--</option>
                        <Universities />
                      </select>
                    </div>
                  ) : selectedProvider === "2" ? (
                    <div className="form-group">
                      <label>
                        Affiliate Partner:<b>*</b>
                      </label>
                      <select
                        className="form-control"
                        name="providerid"
                        value={createDocJson.providerid}
                        onChange={(e) => handleValues(e)}
                      >
                        <option value="0">--Select--</option>
                        <AffiliatePartner />
                      </select>
                    </div>
                  ) : selectedProvider === "3" ? (
                    <div className="form-group">
                      <label>
                        Partner Agent:<b>*</b>
                      </label>
                      <select
                        className="form-control"
                        name="providerid"
                        value={createDocJson.providerid}
                        onChange={(e) => handleValues(e)}
                      >
                        <option value="0">--Select--</option>
                        <Partner />
                      </select>
                    </div>
                  ) : selectedProvider === "4" ? (
                    <div className="form-group">
                      <label>
                        Sub Agent:<b>*</b>
                      </label>
                      <select
                        className="form-control"
                        name="providerid"
                        value={createDocJson.providerid}
                        onChange={(e) => handleValues(e)}
                      >
                        <option value="0">--Select--</option>
                        <SubAgent />
                      </select>
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="form-group">
                    <label>
                      Document Type:<b>*</b>
                    </label>
                    <input
                      type="text"
                      autocomplete="off"
                      className="form-control"
                      placeholder="Enter Document Type"
                      name={"documentType"}
                      value={createDocJson.documentType}
                      onChange={(e) => handleValues(e)}
                    />
                  </div>

                  <div className="form-group">
                    <label>
                      Upload Document:<b>*</b>
                    </label>
                    <input
                      type="file"
                      autocomplete="off"
                      className="form-control"
                      name="document"
                      value={file_input}
                      onChange={(e) => handleValues(e)}
                    />
                  </div>

                  <div class="contact-footer w-100">
                    <button
                      type="button"
                      class="btn"
                      onClick={(e) => handleUpload(e)}
                      disabled={loadingCreate}
                    >
                      {loadingCreate ? "Loading..." : "Upload Document"}
                    </button>

                    <button
                      type="button"
                      class="btn btn-deep-orange waves-effect waves-light"
                      onClick={(e) => setopenCreate(false)}
                    >
                      Cancel
                    </button>
                    <br />
                    <span style={{ color: "red" }}>{errorCreate}</span>
                    <span style={{ color: "green" }}>{success}</span>
                  </div>
                </div>
                {/* <!--/right side create contacts form--> */}
              </div>
            </div>
          </div>
        </div>
      </LeftComponent>
    </>
  );
}
